import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { weight, fontFamilyHelvetica } from "@styles/type.styles";
import { colors } from "@styles/color.styles";
import { FocusedWorker } from "@components/svgs/FocusedWorker";

export interface BannerProps {
  message: React.ReactNode;
  ctaLink: React.ReactNode;
}

const useStyles = makeStyles({
  container: {
    display: "flex",
    fontFamily: fontFamilyHelvetica,
    fontSize: "1rem",
    fontWeight: weight.bold,
    lineHeight: 1.2,
    background: "#EDF5FC",
    borderRadius: 8,
    marginTop: 100,
  },
  message: {
    color: colors.blueCool.darker,
    margin: "0px 0px 16px",
  },
  cta: {
    "& > a": {
      color: colors.green.darker,
    },
  },
  body: {
    padding: "16px 22px",
  },
});

export const Banner = ({ message, ctaLink }: BannerProps) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.body}>
        <p className={classes.message}>{message}</p>
        {ctaLink && <div className={classes.cta}>{ctaLink}</div>}
      </div>
      <FocusedWorker width="100%" height="100%" />
    </div>
  );
};
